import AddonVariant from "src/api/graphql/__generated__/enums/AddonVariant";

// Keeping these lookups generic for backwards compatibility with new variants

export const ADDON_LABELS: Record<string, string> = {
	[AddonVariant.Link]: "LINK",
	[AddonVariant.Spotify]: "LINK",
	[AddonVariant.Venmo]: "VENMO USERNAME",
	[AddonVariant.Location]: "LOCATION",
};
export const ADDON_PLACEHOLDERS: Record<string, string> = {
	[AddonVariant.Link]: "Add RSVP page, groupchats, and more",
	[AddonVariant.Spotify]: "Paste a song, album, or playlist",
	[AddonVariant.Venmo]: "Add your venmo username",
	[AddonVariant.Location]: "Place, name, or link",
};
export const ADDON_HEADERS: Record<string, string> = {
	[AddonVariant.Link]: "Add Link",
	[AddonVariant.Spotify]: "Add Spotify",
	[AddonVariant.Venmo]: "Add Venmo",
	[AddonVariant.Location]: "Add Location",
};
